import React, { useState, useEffect } from 'react'
import FieldDropdown from '../../whitaijiFrontendLibrary/components/FieldDropdown'
import BlueButton from '../BlueButton'
import CheckIcon from './CheckIcon'
import { IoIosInformationCircleOutline } from "react-icons/io";
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import { GiStarsStack } from "react-icons/gi";
import T, { dT } from '../Translation';
import { useStateContext } from '../../context/StateContext';
import { generateMongoDBId } from '../../whitaijiFrontendLibrary/lib/utils';
import ScrollDiv from '../ScrollDiv';
import ClaudeAiCustomDataJson from '../../whitaijiFrontendLibrary/components/ClaudeAiCustomDataJson';
import TestButton from '../TestButton';
import { successAlert } from '../../utils/utils';


const ChooseLyrics = ({data}) => {

    const {language, bookRemind, rawAiConcert, setRawAiConcert,} = useStateContext()

    const {concert, setConcert, songsData, hideTestButtons} = data
    const [selectedSong, setSelectedSong] = useState(undefined)
    const [aiLoading, setAiLoading] = useState(false)
    const [aiJson, setAiJson] = useState(undefined)

    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
    const songsInConcertOptions = concertSongs?.filter((x)=>x?.status !== "archived")?.map((s) => ({label: s?.title, value: s?.songTemplateId}))

    const concertSong = concertSongs?.find((s) => s?.songTemplateId == selectedSong?.value)
    const song = songsData?.find((s) => s?._id == selectedSong?.value)
    const selectedSongs = songsData?.filter((x)=> concert?.songs?.some((y)=>y?.songTemplateId == x?._id))
    const allLyrics = !Array.isArray(song?.lyrics) ? [] : song?.lyrics

    const aiPrompt = `
    You are an accomplished psychologist.
    Do not answer anything that is not related to mental health or personal development.
    You are selecting a number of song lyrics that are part of a concert that are most connected with the user's question, so that they can be highlighted for them
    to concentrate on while they listen.
    Here is the concert's description and theme: ${concert?.aiAnswer}

    CRITICAL!!: Ensure your response is a valid JSON object that can be parsed.
    Analyze the user's input and select between 4 and 12 lyric objects per song in the following songsData, which are the songs in the concert
    VALID RESPONSE STRUCTURE:
    {"selectedLyrics": [
      {...song, "lyrics":[{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"}]}
      {...song, "lyrics":[{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"}]}
      {...song, "lyrics":[{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"}]}
      {...song, "lyrics":[{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"}]}
      {...song, "lyrics":[{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"},{...lyric, "aiDescription": "[briefly explain how this song lyric relates to the user's situation]"}]}
    ]} 
    songsData:
    \n${JSON.stringify(selectedSongs, null, 2)} 

    Then return the same songsData object with ONLY the lyrics you selected in the array, keep the rest of the data unchanged.
    Add to each lyric object you selected a key "aiDescription" brief description of how and why this lyric line applies to the user's prompt.
    each lyric object.

    Give your answer in the language that the user is promping in.
    
    CRITICAL RESPONSE REQUIREMENTS:
    1. Return ONLY a SINGLE JSON object
    2. Response MUST start with "{" and end with "}"
    3. NO text before or after the JSON
    4. NO explanations or additional responses
    5. NO markdown code blocks
    6. ALL properties must use double quotes
    7. NO trailing commas
    8. NO line breaks in string values
    9. DO NOT send any follow-up messages or explanations
    10. DO NOT wrap the JSON in code blocks

    
    INVALID RESPONSE EXAMPLES:
    Here's your JSON: {{"selectedLyrics":...} // No text before/after
    \`\`\`json {"selectedLyrics":...} \`\`\` // No markdown
    {"selectedLyrics":...} Additional text // No extra text
    {"selectedLyrics":...} \n Here's an explanation... // No follow-up text

    `
    const aiQuestion = concert?.aiQuestion

/*     useEffect(() => {
            if (aiJson) {
                process.env.NODE_ENV === "development" && console.log("starting useEffect aiJson jqojdioqwdjioqwdj", {aiJson});
              try {
                let data;
                
                // Check if aiJson is already an object
                if (typeof aiJson === 'object' && aiJson !== null) {
                  data = aiJson;
                } else if (typeof aiJson === 'string') {
                  try {
                    data = JSON.parse(aiJson);
                  } catch (error) {
                    process.env.NODE_ENV === "development" && console.error('Error parsing JSON string:', error);
                    return;
                  }
                } else {
                  process.env.NODE_ENV === "development" && console.error('Invalid aiJson type:', typeof aiJson);
                  return;
                }
    
                // Validate the data structure
                if (!data || typeof data !== 'object') {
                  throw new Error('Invalid JSON structure: not an object');
                }
    
                if (!Array.isArray(data?.selectedLyrics) || data?.selectedLyrics === 0) {
                  throw new Error('Invalid JSON structure: missing or empty selectedLyrics array');
                }
    
                // If we got here, the data is valid
                process.env.NODE_ENV === "development" && console.log("Setting concert data:", data);
                const newProcessedConcert = {...concert, songs: concert.songs.map((s) => {
                   const findSongInAiResponse = data?.selectedLyrics?.find((x)=> x?._id == s?.songTemplateId) 
                   const newDoc = {...s, lyrics: findSongInAiResponse?.lyrics} 
                   return newDoc 
                })}
                console.log("====UPDATING CONCERT=====", {newProcessedConcert, concert})
                //setConcert(newProcessedConcert);
              } catch (error) {
                process.env.NODE_ENV === "development" && console.error('Error processing AI response:', error);
                process.env.NODE_ENV === "development" && console.error('Error details:', error.message);
              }
            }
          }, [aiJson]); */
          
        // New useEffect to handle rawAiConcert updates
/*         useEffect(() => {
          // Skip if rawAiConcert is undefined or null
          if (!rawAiConcert) {
            return;
          }
          process.env.NODE_ENV === "development" && console.log("Use effect called with rawAiConcert wlqdjwldjewidj starting", {rawAiConcert});
          try {
            process.env.NODE_ENV === "development" && console.log("Processing rawAiConcert:", rawAiConcert);
            
            // Extract the raw response text
            const rawResponseText = rawAiConcert.rawResponse;
            
            if (!rawResponseText) {
              process.env.NODE_ENV === "development" && console.error('No raw response text found in rawAiConcert');
              return;
            }
            
            // Try to parse the JSON from the raw response
            let jsonContent;
            try {
              // First, check if the raw response is a Claude API response object
              const claudeResponse = JSON.parse(rawResponseText);
              
              // If it has a content array, extract the text from the first content item
              if (claudeResponse.content && Array.isArray(claudeResponse.content) && claudeResponse.content.length > 0) {
                process.env.NODE_ENV === "development" && console.log("Found Claude API response structure");
                
                // Extract the text content which contains our JSON
                const textContent = claudeResponse.content[0].text;
                process.env.NODE_ENV === "development" && console.log("Extracted text content:", textContent);
                
                // Parse the JSON from the text content
                jsonContent = JSON.parse(textContent);
              } else {
                // If it's not a Claude API response, try to find JSON in the raw response
                const jsonMatch = rawResponseText.match(/\{[\s\S]*\}/);
                if (jsonMatch) {
                  jsonContent = JSON.parse(jsonMatch[0]);
                } else {
                  // If no JSON object found, try parsing the whole response
                  jsonContent = JSON.parse(rawResponseText);
                }
              }
              
              process.env.NODE_ENV === "development" && console.log("Successfully parsed JSON from raw response:", jsonContent);
            } catch (parseError) {
              process.env.NODE_ENV === "development" && console.error('Error parsing JSON from raw response:', parseError);
              process.env.NODE_ENV === "development" && console.log('Raw response content:', rawResponseText);
              return;
            }
            
            // Validate the parsed JSON structure
            if (!jsonContent || typeof jsonContent !== 'object') {
              process.env.NODE_ENV === "development" && console.error('Invalid JSON structure: not an object', jsonContent);
              return;
            }
            
            // Log the parsed JSON content for debugging
            process.env.NODE_ENV === "development" && console.log("Parsed JSON content:", jsonContent);
          
            
            // If we got here, the data is valid
           
            setAiJson(jsonContent)
            const newConcert = {
              ...concert, 
              songs: concert?.songs?.map((s) => { 
                const findResponseSong = jsonContent.selectedLyrics.find((x) => x._id == s.songTemplateId)
                if(!findResponseSong) return s
                if(findResponseSong?.lyrics || !Array.isArray(findResponseSong?.lyrics)) return s
                return {...s, lyrics: findResponseSong?.lyrics}
              })
            };
             process.env.NODE_ENV === "development" && console.log("Potentially Setting concert data from rawAiConcert:", {jsonContent, newConcert});
             setConcert({newConcert});
            
            // Update the UI fields

            
            // Clear rawAiConcert after successful processing
            setRawAiConcert(undefined);
            successAlert();
            
          } catch (error) {
            process.env.NODE_ENV === "development" && console.error('Error processing raw AI response:', error);
            process.env.NODE_ENV === "development" && console.error('Error details:', error.message);
          }
        }, [rawAiConcert]); */

    const consoleData =  {
        concert,
        aiPrompt,
        songsData,
        selectedSongs,
        concertSong,
        song,
        bookRemind,
        aiJson
    }

    return (
        <div>
            <div style={{marginTop:"20px", marginBottom:"20px"}}>
                <TestButton consoleData={consoleData} buttonId='odqijdiqywegd' message="choose Lyrics"/>
{/*                 <ClaudeAiCustomDataJson 
                    customData={bookRemind} 
                    systemPrompt={aiPrompt} 
                    strict={true}
                    aiQuestion = {aiQuestion}
                    setAiJson={setAiJson}
                    loadingCallback={setAiLoading}
                    buttonText={dT({en:"Choose Lyrics With Ai", it:"Scegli le psarole con Ia"}, language)}
                /> */}
            </div>
            <FieldDropdown
                options={songsInConcertOptions}
                onChange={(e) => {
                    setSelectedSong(e)
                }}
                value={selectedSong}
                placeHolder= {dT({
                    en: "Select a song",
                    it: "Seleziona una canzone"}, language
                )}
            />
            {!selectedSong &&             
                <div> 
                    <ScrollDiv>
                    {concert?.songs?.map((song, index) => 
                            <div 
                            key={index}
                            className="scroll-item" style={{
                                display: "flex", 
                                width: "370px",
                                minWidth: "370px",
                                padding: "15px", 
                                borderRadius: "10px", 
                                border: "1px solid #ccc", 
                                margin: "10px",
                                flexDirection: "column",
                                background: "white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                              }}>
                            <h3>{song?.title}</h3>
                            {!Array.isArray(song?.lyrics) ? [] : song?.lyrics?.filter((x)=> x?.status !== "archived")?.map((lyric, index) => 
                                <div style={{padding:"10px"}} key={index}>
                                    <p>{lyric?.text}</p>
                                    <div style={{color:"gray", padding:"10px"}}>
                                        <div style={{marginRight:"10px"}}>
                                        <GiStarsStack size={18}/>
                                        </div>
                                        <p>{lyric?.aiDescription}</p>
                                    </div>
                                </div>
                            )}
                        </div>)
                    }   
                   

                    </ScrollDiv>
                </div>
            }

            <div style={{textAlign:"center", margin:"20px"}}>
                <h2>{song?.title}</h2>
            </div>
           
            {!Array.isArray(allLyrics) ? [] : allLyrics?.filter((x)=> x?.time !== 0)?.map((lyric, index) => 
               <div key={index}> 
                    {lyric?.firstLineInParagraph && <div style={{marginTop: "30px", marginBottom: "30px"}}>
                        <h3>{lyric?.sectionTitle}</h3>
                        </div>}
                    <LyricPin data={{lyric, concert, setConcert, song, concertSong}} />
               </div>)}
        </div>
    )
}

export default ChooseLyrics

export const LyricPin = ({data}) => {

    const {lyric, concert, setConcert, concertSong, song, } = data 
    const [showInfo, setShowInfo] = useState(false)
    const onInfoClick = (e) => {
        e.stopPropagation()
        setShowInfo(!showInfo)
    }
    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
    const concertSongLyrics = !Array.isArray(concertSong?.lyrics) ? [] : concertSong?.lyrics
    const lyricInConcertSong = !Array.isArray(concertSongLyrics) ? undefined : concertSongLyrics.find((l) => l?.lyricTemplateId == lyric?._id)
    const isLyricInConcertSong = !Array.isArray(concertSongLyrics) ? false : concertSongLyrics.some((l) => l?.lyricTemplateId == lyric?._id)
    const isLyricArchived = !Array.isArray(concertSongLyrics) ? false : concertSongLyrics.some((l) => l?.lyricTemplateId == lyric?._id && l?.status == "archived")

    const archivedLyric = {text: lyric?.text, lyricTemplateId: lyric?._id, _id: lyricInConcertSong?._id, aiDescription: lyricInConcertSong?.aiDescription || undefined, status: "archived"}
    const activeSong = {text: lyric?.text, lyricTemplateId: lyric?._id,  _id: lyricInConcertSong?._id, aiDescription: lyricInConcertSong?.aiDescription || undefined, status: "active"}

    const onClickPin = () => {
        if(!isLyricInConcertSong) {
            const newLyrics = [...concertSongLyrics, {text: lyric?.text, _id: generateMongoDBId(), lyricTemplateId: lyric?._id, status: "active"}]
            const newSong = {...concertSong, lyrics: newLyrics}
            const newSongs = [...concertSongs?.filter((s) => s?.songTemplateId != song?._id), newSong]
            setConcert({...concert, songs: newSongs})
        }
        if(isLyricInConcertSong && !isLyricArchived) {
            const newLyrics = [...concertSongLyrics?.filter((s) => s?.lyricTemplateId != lyric?._id), archivedLyric]
            const newSong = {...concertSong, lyrics: newLyrics}
            const newSongs = [...concertSongs?.filter((s) => s?.songTemplateId != song?._id), newSong]
            setConcert({...concert, songs: newSongs})

        }
        if(isLyricInConcertSong && isLyricArchived) {
            const newLyrics = [...concertSongLyrics?.filter((s) => s?.lyricTemplateId != lyric?._id), activeSong]
            const newSong = {...concertSong, lyrics: newLyrics}
            const newSongs = [...concertSongs?.filter((s) => s?.songTemplateId != song?._id), newSong]
            setConcert({...concert, songs: newSongs})
        }
    }
    
    return (
        <>
        <div style={{margin:"10px", display:"flex", alignItems:"center", padding:"3px",}}>
            <div onClick={onClickPin} style={{cursor:"pointer", marginRight:"10px"}}>
                <CheckIcon status={isLyricInConcertSong && !isLyricArchived}/>
            </div>        
            <div>
                {lyric.text}
            </div>
            <VisDiv onClick={onInfoClick} style={{marginLeft:"10px", cursor:"pointer"}} rules={[lyricInConcertSong?.aiDescription]}>
                <IoIosInformationCircleOutline size={25}/>
            </VisDiv>

        </div>
        <VisDiv style={{border:"1px dotted #ccc", marginLeft:"30px", padding:"10px", color:"gray"}} rules={[showInfo]}>
            <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                <div style={{marginRight:"10px"}}>
                 <GiStarsStack size={18}/>
                </div>
                <div style={{fontWeight:"bold"}}>
                    <T obj={{en:"reMind ai says:", it: "reMind ia spiega:"}}/>
                </div>
                
            </div>
            <p>{lyricInConcertSong?.aiDescription}</p>
        </VisDiv>
        </>
    )
}


